<template>
  <div class="security-verification">
    <i class="back-icon iconfont icon-fanhuianniu" :class="{mirrorRotateLevel:isDirection}" @click="handleBack()"> </i>
    <p class="title">{{ $t('300042') }}</p>
    <div class="tab" v-if="isGoogle && type == 'email'">
      <div class="pointer tab-item marR32 inline-block bold" @click="handleChange('google')"
           :class="{activeTab:activeType == 'google'}">{{$t('300331')}}
      </div>
      <div class="pointer tab-item inline-block bold" @click="handleChange('email')"
           :class="{activeTab:activeType == 'email'}">{{ $t('300033') }}
      </div>
    </div>
    <div class="form">
      <div class="form-item" v-if="activeType == 'google'">
        <span class="block label">{{ $t('300329') }}</span>
        <input v-model="code" maxlength="6" @blur="inputBlur" @input="handleInput"/>
        <span class="block tip" :class="errorTip ? 'errorTip' : 'normalTip'">{{ tip }}</span>
      </div>
      <div class="form-item" v-if="activeType == 'sms'">
        <span class="block label">{{ $t('300052') }}</span>
        <div class="value">
          <input type="text" v-model="code" maxlength="6" @blur="inputBlur" @input="handleInput">
          <sendCode :isCountDown="isCountDown" :user-name="userName" :code-type="type"
                    :form-type="formType"
                    :interfaceType="interfaceType"
                    :country-code="areaCode"
                    :validationToken="validationToken"
                    :isGeet="isGeet"
                    :errorFun="errorFun"
                    :successFun="successFun"
                    :countDownFun="countDownFun"
          ></sendCode>
        </div>
        <span class="block tip" :class="errorTip ? 'errorTip' : 'normalTip'">{{ tip }}</span>
      </div>
      <div class="form-item" v-if="activeType == 'email'">
        <span class="block label">{{ $t('300051') }}</span>
        <div class="value">
          <input type="text" v-model="code" maxlength="6" @blur="inputBlur" @input="handleInput">
          <sendCode
            :isCountDown="isCountDown"
            :user-name="userName"
            :code-type="type"
            :form-type="formType"
            :interfaceType="interfaceType"
            :errorFun="errorFun"
            :successFun="successFun"
            :validationToken="validationToken"
            :countDownFun="countDownFun"
          ></sendCode>
        </div>
        <span class="block tip" :class="errorTip ? 'errorTip' : 'normalTip'">{{ tip }}</span>
      </div>
      <div class="form-item">
        <van-button class="form-btn" :disabled="isDisabled" :class="{'disabledBtn':isDisabled}"
                    @click="submitCode">
          {{ $t('300056') }}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Methods from "../utils/methods";
import sendCode from "./sendCode";
import {Button} from 'vant'
import {mapGetters} from "vuex";

export default {
  name: "verification",
  data() {
    return {
      activeType: '',
      code: '',
      // googleCode: '',
      // smsCode: '',
      // emailCode: '',
      tip: '',
      errorTip: false,
    }
  },
  props: {
    interfaceType: {// 接口类型
      type: String,
      default: ''
    },
    userName: {   // 用户手机号/邮箱
      type: String,
      default: ''
    },
    type: {   // 类型
      type: String,
      default: ''
    },
    isGoogle: {  // 是否显示谷歌
      type: [Boolean, Number],
      default: false
    },
    areaCode: {  // 区号
      type: String,
      default: ''
    },
    isGeet: {  // 极验
      type: Boolean,
      default: false
    },
    formType: {  // 表单类型
      type: String,
      default: ''
    },
    validationToken: { //验证token
      type: String,
      default: ''
    },
    isCountDown: { // 是否直接启动倒计时
      type: Boolean,
      default: false
    }
  },
  components: {sendCode, vanButton: Button},
  computed: {
    isDisabled() {
      return this.code.length < 6
    },
    ...mapGetters(['isDirection'])
  },
  created() {
    if (this.$route.query.backgroundColor !== undefined && this.$route.query.backgroundColor !== '') {
      window.document.documentElement.setAttribute(
        'data-theme',
        this.$route.query.backgroundColor === 'day' ? 'sunlight' : 'moon'
      );
    } else {
      window.document.documentElement.setAttribute('data-theme', 'sunlight');
    }
    this.activeType =  this.type == 'email' && this.isGoogle ? 'google' : this.type == 'phone' ? 'sms' : this.type == 'email' && !this.isGoogle ? 'email' : 'google'
    this.tip = this.activeType == 'sms' ? this.$t('300057', {phone: Methods.telephoneShow(this.userName)}) : this.activeType == 'google' ? this.$t('300059') : this.activeType == 'email' ? this.$t('300058', {email: Methods.emailShow(this.userName)}) : ''
  },
  methods: {
    submitCode() {
      this.$emit('submitFun', this.code, this.activeType)
    },
    countDownFun() {
      this.$emit('countDownFun')
    },
    errorFun() {
      this.$emit('submitError')
    },
    successFun() {
      this.$emit('submitError')
    },
    handleChange(type) {
      this.activeType = type
      this.code = ''
      this.errorTip = false
      if (type == 'google') {
        this.tip = this.$t('300059');
      } else {
        this.tip = this.$t('300058', {email: Methods.emailShow(this.userName)})
      }
    },
    // 验证输入框
    inputBlur() {
      if (this.code.length < 6) {
        this.errorTip = true
        this.tip = this.$t('300060')
      }
    },
    handleInput() {
      this.code = this.code.replace(/[^\d]/g, '')
      if (this.code.length == 6) {
        this.errorTip = false
        this.tip = ''
      }
    },
    handleBack() {
      this.$emit('backFun')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";
@import "../assets/css/mixin";

.block {
  display: block;
}
[dir='ltr'] {
  .marR32 {
  margin-right: torem(16);
}

}
[dir='rtl'] {
  .marR32 {
  margin-left: torem(16);
}

}

.security-verification {
  padding: torem(17) torem(28);

  .back-icon {
    display: inline-block;
    @include sc(torem(14), #999);
    line-height: torem(22);
    margin-bottom: torem(28);
  }

  .title {
    // @include sc(torem(24), #333);
    font-size: torem(24);
    @include font_color("font-color");
    margin-bottom: torem(48);
  }

  .tab {
    width: 100%;
    border-bottom: torem(1) solid;
    @include border_color("border-color-1");
    padding: 0 torem(6);
    // overflow-y: auto;
    display: flex;
    .tab-item {
      padding-bottom: torem(5);
      font-size: torem(15);
      color: #7F8490;
      flex-shrink: 0;
    }

    .activeTab {
      border-bottom: torem(3) solid #FFC72B;
      @include font_color("font-color-1");
    }
  }

  .form {
    .form-item {
      margin-bottom: torem(24);

      .label {
        // @include sc(torem(16), #333);
        @include font_color("font-color");
        margin-bottom: torem(8);
        margin-top: torem(24);
        font-size: torem(13);
      }

      input {
        height: torem(46);
        border: torem(1) solid;
        text-indent: torem(12);
        width: 100%;
        border-radius: torem(1);
        // @include sc(torem(14), #333);
        font-size: torem(14);
        @include border_color("border-color-1");
        @include font_color("font-color");
        @include background_color("background-color-7");
      }

      .errorBorder {
        /deep/ .el-input__inner {
          border-color: #D35D5D;
        }
      }

      .tip {
        @include sc(torem(12), #999);
        margin-top: torem(10);
        line-height: 1.2;
      }

      .normalTip {
      }

      .errorTip {
        color: #D35D5D;
      }

      .value {
        position: relative;
        
      }
    }

    /deep/ .van-button {
      width: 100%;
      height: torem(44);
      @include sc(torem(16), #333);
      background-color: #FFC72B;
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/verification.vue